// istanbul ignore file
export const UPDATE_FLEX_BUY_PAYMENT = 'UPDATE_FLEX_BUY_PAYMENT';
